import { Request } from "../Request";
import { BASE_URL } from "../../constants/urls";

export const saveBonus = async (data: any) => {
  return Request.post("/bonus", { data: data });
};

export const getBonus = async (id: any) => {
  return Request.get(`/bonus/${id}`, {});
};

export const getAll = async () => {
  return Request.get(`/bonus`, {});
};

export const getCount = async () => {
  return Request.get(`/bonuses/get-count`, {});
};

export const getActive = async () => {
  return Request.get(`/bonuses/get-active`, { noAuth: true });
};

export const deleteBonus = async (id: any) => {
  return Request.del(`/bonus/${id}`, {});
};

export const updateBonus = async (id: any, data: any) => {
  return Request.put(`/bonus/${id}`, { data: data });
};

export async function uploadImage(image: File) {
  const formData = new FormData();
  formData.append("image", image);
  try {
    const response = await fetch(`${BASE_URL}/media`, {
      method: "POST",
      body: formData,
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      alert("Something went wrong! Try Again.");
    }
  } catch (error) {
    alert("Something went wrong! Try Again.");
  }
}
